import {ModuleConfiguration} from "../router/model/UserPermission";
import {
    AngularJsSliderModuleName,
    BranchServiceModuleName,
    FilterComponentsModuleName
} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const FilterComponentsModuleConfiguration = new ModuleConfiguration(
    FilterComponentsModuleName, [
        AngularJsMaterialModuleName,
        FilterComponentsModuleName,
        BranchServiceModuleName,
        AngularJsSliderModuleName
    ]
);